import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import { Api } from '../../componentes/Api';



export const VentasLineas = ({ data }) => {
    const [ListadoLineas, SetListadoLineas] = useState([]);

    useEffect(() => {
        obtenerDatosLineas();
    }, [])

    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasLineas/" + data.pedidoID);
        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)
        }
    }
    const columns1 = [
        {
            name: 'Art.ID',
            selector: row => row.articuloID,
            sortable: true,
            width: "10%",

        },
        {
            name: 'Descripcion',
            selector: row => (

                row.descripcionArticulo),
            sortable: true,
            width: "40%"
        }, {
            name: 'Cantidad',
            selector: row => (row.cantidad),
            sortable: true,
            width: "10%",
        }, {
            name: 'Precio',
            selector: row => (toMoney(row.precio)),
            sortable: true,
            width: "15%",
        }, {
            name: 'Descuento',
            selector: row => (toMoney(row.descuento)),
            sortable: true,
            width: "10%",
        }, {
            name: 'Total',
            selector: row => ((toMoney(row.totalLinea))),
            sortable: true,
            width: "10%",
        },


    ];
    const toMoney = (value) => {
        const money = Number(value);

        if (isNaN(money)) {
            return value;
        }

        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
    }

    //Diseño tabla
    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
                paddingRight: '1px',
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
                minHeight: '30px',
            }
        }
    };
    return (
        <>
            <DataTable
                columns={columns1}
                data={ListadoLineas}
                //progressPending={pendiente1}
                //  pagination
                //    paginationComponentOptions={paginationComponentOptions}
                customStyles={customStyles}
            />
        </>
    )
}
